module.exports = __webpack_public_path__ + "img/user-for-openbadge-popup-invite-top.3080fef8.png";